import React, { useState } from "react";

import greenPatternFull from '../assets/images/bottom-pattern copy.png'
import greenPatternHalf from '../assets/images/bottom-pattern.png'
import whitePattern from '../assets/images/white-pattern.svg'

import investorConnectLogo from '../assets/images/logos/investor-connect-transparent-logo.png'

import { useNavigate } from "react-router-dom";

import Header from "../layout/header";
import IP from "../variable";
import axios from 'axios';
import { useMutation } from 'react-query';

import toast from 'react-hot-toast';
import { useStore } from "../App";
import { Spinner } from "reactstrap";



const LandingPage = () => {

    const [showLogin, setShowLogin] = useState(false);
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // login functionality
    const sendLogin = (payload) => {
        return axios.post(`${IP}/accounts/login`, payload)
    }

    const sendLoginMutation = useMutation(sendLogin, {
        onSuccess: (data) => {
            console.log('success data', data)

            if (!!data?.data?.access) {

                const response = data?.data

                useStore.setState({ userStatus: true })
                useStore.setState({ accessToken: response.access })
                useStore.setState({ refreshToken: response.refresh })
                useStore.setState({ name: response.name })
                useStore.setState({ email: response.email })
                useStore.setState({ userType: response.user_type })

                if (response?.user_type == "company") {
                    useStore.setState({ location: response.location })
                }

                navigate('/dashboard');
            }
        },

        onError: (data) => {
            if (data?.response?.data?.message) {
                toast.error(data?.response?.data?.message)
            }
            else {
                toast.error('Something went wrong')
            }

        }
    })

    const submit = (e) => {
        e.preventDefault(); // Prevent form refresh


        // Validate email
        if (!email) {
            toast.error('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }

        // If validation passes, submit the form
        sendLoginMutation.mutate({ 'email': email })
    }

    // Handle email input change and clear error when user starts typing
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (emailError) {
            setEmailError(''); // Clear error when user starts typing
        }
    }

    return (
        <div className="landing-page">
            <Header />

            {
                showLogin ?

                    <div className={`modal-bottom-sheet d-flex flex-column align-items-center ${showLogin ? 'show' : ''}`}>

                        <img className="main-logo" src={investorConnectLogo} alt="" />
                        <br />

                        <form onSubmit={submit} style={{ textAlign: 'center' }}>
                            <input
                                type="email"
                                value={email}
                                onChange={handleEmailChange}
                                placeholder="Enter your email"
                                className={emailError ? 'error' : ''}
                            />
                            <br />

                            <button className="mt-2" type="submit" disabled={sendLoginMutation.isLoading}>
                                {sendLoginMutation.isLoading ? (
                                    <>
                                        <Spinner color="light" size="sm" />
                                        <span style={{ fontSize: "inherit", color: "inherit" }}>{' '}Loading...</span>
                                    </>
                                ) : (
                                    'Enter'
                                )}
                            </button>
                        </form>

                        <img style={{position: 'absolute', bottom: 0}} className="green-pattern d-block d-sm-none" src={greenPatternHalf} alt="" />
                        <img style={{position: 'absolute', bottom: 0}} className="green-pattern d-none d-sm-block" src={greenPatternFull} alt="" />
                    </div>

                    :

                    <>
                        <div className="d-flex justify-content-center" style={{ marginTop: '60px' }}>
                            <img className="main-logo" src={investorConnectLogo} alt="" />
                        </div>
                        <div className="d-flex flex-column align-items-center">
                            <button onClick={() => setShowLogin(!showLogin)} className="cursor-pointer mt-4 mb-4 full-width-btn">Company</button>
                            <button onClick={() => setShowLogin(!showLogin)} className="cursor-pointer full-width-btn">Investor</button>
                        </div>
                    </>
            }
            <img src={whitePattern} className="green-pattern d-block d-sm-none" alt="" />
        </div>
    )
}

export default LandingPage;